module.exports = __webpack_public_path__ + "static/Syberia4-abbc5aed6b733da240f73fad5784a92c.webp";